import React, { createContext, useState, useEffect } from 'react'
import cptCodesService from '../services/cpt_codes';
import { extractToken } from '../utils/localStorage';

export const CPTCodesContext = createContext()

export const CPTCodesProvider = ({ children }) => {
  const [cptOptions, setCptOptions] = useState([]);
  const token = extractToken();
  // console.log("token:", token);

  useEffect(() => {
    if (token?.type === "access") {
 
  
      fetchCptCodes();
  }

  }, [])

  const fetchCptCodes = async () => {
    try {

      const response = await cptCodesService.getCptCodesList();
      setCptOptions(response?.data?.results?.map(item => ({
        label: `${item.code} - ${item.description}`,
        value: `${item.code} - ${item.description}`,
      })) || []);
    }
    catch(err) {
      
    }
  };
  
  return (
    <CPTCodesContext.Provider value={{ cptOptions, setCptOptions }}>
      {children}
    </CPTCodesContext.Provider>
  );
};
